export const ApiResponse = {
	EXITO: "EXITO",
	ERROR: "ERROR",
};
